// src/scripts/vendor/init-swiper.js
window.initSwiper = function(el, options, immediate = false) {
  if (!el) return;
  if (typeof el === "string") {
    el = document.querySelector(el);
  }
  if (!(el instanceof Element)) return;
  const create = () => {
    if (el.swiper) return el.swiper;
    el.dataset.swiperInitialized = "true";
    el.swiper = new Swiper(el, options);
    return el.swiper;
  };
  if (immediate) {
    return create();
  }
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        create();
        observer.unobserve(entry.target);
      });
    },
    {
      rootMargin: "200px"
    }
  );
  observer.observe(el);
  return null;
};
